module.exports = ".modal-dialog {\n  width: 80%;\n  height: 80%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-billing-list/att-title-modal/att-title-modal.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-billing-list/att-title-modal/att-title-modal.component.scss
// module chunks = main